import React from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {};

export class CrashMessage extends React.Component<Props> {
  render() {
    return (
      <p className="crash-message">
        <FormattedMessage id="components/crash/CrashMessage.tsx/1" />
        <br />
        <FormattedMessage id="components/crash/CrashMessage.tsx/2" />{' '}
        <button
          type="button"
          className="crash-message__action"
          onClick={() => window.Intercom('show')}
        >
          <FormattedMessage id="components/crash/CrashMessage.tsx/3" />
        </button>
        <FormattedMessage id="components/crash/CrashMessage.tsx/4" />
        <a href="mailto:contact@doctrine.fr">
          <FormattedMessage id="components/crash/CrashMessage.tsx/5" />
        </a>
        <FormattedMessage id="components/crash/CrashMessage.tsx/6" />
        <br />
        <FormattedMessage id="components/crash/CrashMessage.tsx/7" />
      </p>
    );
  }
}
